let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ilmM")).then(() => parcelRequire('56IEh'));